<div class="subscription-upgrade min-vh-100 bg-white p-3 p-md-5">
  <div class="upgrade-container mx-auto">
    <div class="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4">
      <div>
        <h1 class="font-weight-bold mb-2">Upgrade Subscription</h1>
        <p class="mb-0 text-muted">{{ accountTypeLabel }} plans available for your account.</p>
      </div>
      <button mat-stroked-button routerLink="/free-subscription" type="button" [disabled]="isBusy">Back</button>
    </div>

    <div class="w-full h-[280px] flex items-center justify-center" *ngIf="isLoading">
      <mat-spinner diameter="50"></mat-spinner>
    </div>

    <ng-container *ngIf="!isLoading">
      <div class="d-flex flex-wrap justify-content-center mb-4">
        <div
          *ngFor="let subscription of subscriptionOptions"
          class="p-2 computer seven tablet sixteen mobile column flex-center subscription-item"
          [attr.aria-disabled]="isBusy"
          (click)="selectSubscription(subscription)"
        >
          <div class="sub-container cursor-pointer" [class.selected]="subscription.selected">
            <div class="flex items-center justify-center">
              <img class="w-full h-auto px-4" [src]="subscription.imageUrl" [alt]="subscription.name" />
            </div>
            <div class="content text-center flex flex-center">
              <a class="header"><b>{{ subscription.name }}</b></a>
              <div class="meta">
                <span><b>{{ subscription.athleteLimit }} </b></span><span>{{ participantLabel }}</span>
              </div>
              <div class="meta">
                <span class="date"><b>${{ subscription.price }}</b> / month</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="center-buttons mx-auto mb-4 action-panel">
        <button
          mat-flat-button
          color="primary"
          class="w-100"
          type="button"
          [disabled]="!selectedSubscription || isBusy || requiresPaymentMethodUpdate"
          (click)="applySubscription()"
        >
          <ng-container *ngIf="!isBusy">Apply</ng-container>
          <ng-container *ngIf="isBusy">Loading...</ng-container>
        </button>
      </div>

      <div class="alert alert-danger mx-auto mb-4" *ngIf="paymentError">
        {{ paymentError }}
      </div>

      <app-update-payment-info-dialog
        *ngIf="showPaymentForm"
        class="payment-form d-block mx-auto"
        mode="subscriptionUpgrade"
        [title]="hasPaymentMethod ? 'Update payment info' : 'Add payment info'"
        [hasPaymentMethod]="hasPaymentMethod"
        [disabled]="isApplying || isCompleting"
        [attemptPaymentPayload]="attemptPaymentPayload"
        (paymentMethodSaved)="handlePaymentMethodSaved()"
        (busyChange)="isPaymentFormBusy = $event"
        (paymentSucceeded)="handlePaymentSucceeded()"
        (paymentFailed)="handlePaymentFailed($event)"
      ></app-update-payment-info-dialog>
    </ng-container>
  </div>
</div>
